<template>
  <div>
    <help-hub-breadcrumb
      v-show="!isLoading"
      :is-self-service="false"
      :title="breadcrumbTitle"
      :key="breadCrumbComponentKey"
      class="profile-page"
    ></help-hub-breadcrumb>
    <loading-overlay v-if="isLoading"></loading-overlay>
    <div v-show="!isLoading">
      <help-hub-user-profile
        :user-id="userName"
        :current-user-access-token="currentToken"
        :is-helphub-app="true"
        title="Profile Page"
        :show-user-profile="showUserProfile"
        :scroll-to-devices="scrollToDevices"
        :open-team-defaults-modal="openTeamDefaultsModal"
        :scroll-to-delegates="scrollToDelegates"
        :key="componentKey"
        @onProfilePageComponentSuccess="onProfilePageComponentSuccess"
        @onTeamDataSuccess="onTeamDataSuccess"
      />
    </div>
  </div>
</template>
<script>
import { safeImportComponent } from "@/utils/componentImportUtils";
import router from "../../router";
import LoadingOverlay from "@/components/LoadingOverlay";
import { mapGetters } from "vuex";

export default {
  name: "profile-page",
  components: {
    LoadingOverlay
  },
  data() {
    return {
      appEnv: CURRENT_ENV,
      isLoading: true,
      userName: null,
      currentDisplayList: null,
      currentToken: null,
      componentKey: 0,
      breadCrumbComponentKey: 0,
      showUserProfile: true,
      breadcrumbTitle: null,
      scrollToDevices: false,
      openTeamDefaultsModal: false,
      scrollToDelegates: false
    };
  },
  computed: {
    ...mapGetters(["authResponse", "user"])
  },
  watch: {
    "user.userName": function() {
      this.init(this.authResponse.user.userName, this.authResponse.accessToken);
      this.isLoading = true;
      this.showUserProfile = true;
      //Re triggers the component
      this.componentKey++;
      this.breadCrumbComponentKey++;
    }
  },
  created() {
    this.init();
  },
  methods: {
    init(user, token) {
      let currentUser = null;

      if (!this.$route.params.userName) {
        currentUser = this.authResponse.user.userName;
      } else {
        currentUser = user ? user : this.$route.params.userName;
      }

      if (currentUser) {
        this.userName = currentUser;
      }

      const userToken = token ? token : this.authResponse.accessToken;
      this.currentToken = userToken;
      const loggedUser = this.authResponse.user.userName;

      if (this.userName !== loggedUser) {
        this.showUserProfile = false;
      }
      safeImportComponent(HH_COMPONENTS_URL + "/helphubprofile.umd.min.js");
      this.$nextTick(() => {
        this.componentKey++;
      });
    },
    onProfilePageComponentSuccess(response) {
      if (this.$route.name === "profile-page-devices") {
        this.scrollToDevices = true;
      }

      if (this.$route.name !== "profile-page-team") {
        this.isLoading = false;
      }

      if (this.$route.name === "profile-page-delegates") {
        this.scrollToDelegates = true;
      }

      if (response) {
        this.breadcrumbTitle = `${response.detail[0].fullName}'s Profile`;
      } else {
        this.breadcrumbTitle = "Profile";
      }
      this.breadCrumbComponentKey++;
    },
    onTeamDataSuccess(response) {
      this.isLoading = false;
      if (this.$route.name === "profile-page-team") {
        if (!response.detail[0].isManager) {
          router.push({ name: "Forbidden" });
        }
        this.openTeamDefaultsModal = response.detail[0].isManager;
      }
    }
  }
};
</script>
<style scoped>


@media screen and (min-width: 0px) and (max-width: 1279px) {
  help-hub-breadcrumb >>> .breadcrumb-title {
    font-size: 26px !important;
  }
}

@media screen and (min-width: 0px) and (max-width: 539px) {
  help-hub-breadcrumb >>> .bookmark-icon {
    margin-left: 10px !important;
  }
  help-hub-user-profile >>> .user-panel-name-text {
    font-size: 20px !important;
  }
  help-hub-user-profile >>> .panel-default {
    margin-top: 60px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/profile/ProfilePage.vue